import { ReservedInventoryBucketKind } from "@redotech/crdb-enums/inventory/reserved-inventory-bucket-kind";
import {
  customReservedInventoryBucketTypeIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getReservedInventoryBuckets = {
  name: "getReservedInventoryBuckets" as const,
  input: z.object({
    productId: productIdFormat.schema,
    locationId: locationIdFormat.schema,
  }),
  output: z.object({
    buckets: z.array(
      z.object({
        kind: createEnum(ReservedInventoryBucketKind).nullable(),
        customTypeId:
          customReservedInventoryBucketTypeIdFormat.schema.nullable(),
        customTypeName: z.string().nullable(),
        quantity: z.number(),
        imsQuantity: z.number(),
        wmsQuantity: z.number(),
        totalQuantity: z.number(),
      }),
    ),
  }),
};
